import component from './ProgressivePicture';

export default component;
